import { useDispatch, useSelector } from "react-redux";
import { downloadExchangeMembersReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useExchangeMemberReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchangeMember.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadExchangeMembersReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
